<template>
  <v-calendar type="day"
              hide-header
              start="2000-01-01"
              :events="processedEvents"
              @click:event="eventClicked"
              :interval-height="intervalHeight"
  >
    <template v-slot:event="{event}">
      <div class="event-body-container text-center">
        <label class="event-body-label">{{ event.name }}</label>
      </div>
    </template>
  </v-calendar>
</template>

<script>
import {ref, watch, computed} from "@vue/composition-api";
import {DateTime} from 'luxon';

export default {
  name: 'DayScheduleTimeLine',
  props: {
    value: Array,
    intervalHeight: {
      type: Number || String,
      defaultValue: 48
    }
  },
  setup(props, {root, emit}) {
    const events = ref(props.value || []);
    watch(() => props.value, (newValue, oldValue) => {
      events.value = newValue;
    });
    const processedEvents = computed(() => {
      return events.value.map((e) => {
        if (DateTime.fromFormat(e.end, 'yyyy-MM-dd HH:mm') >= DateTime.fromFormat('2000-01-02 00:00', 'yyyy-MM-dd HH:mm')) {
          return {
            ...e,
            end: '2000-01-01 23:59',
          }
        }
        return e;
      });
    });

    const eventClicked = function (e) {
      emit('click:event', e);
    };


    // const dragEvent = ref(null);
    // const dragTime = ref(null);
    // const extendOriginal = ref(null);
    // const createStart = ref(null);
    // const createEvent = ref(null);
    //
    // const toTimeStamp = function (date) {
    //   const year = date.getFullYear();
    //   const month = (date.getMonth() + 1).toString().padStart(2, '0');
    //   const day = date.getDate().toString().padStart(2, '0');
    //   const hour = date.getHours().toString().padStart(2, '0');
    //   const minute = date.getMinutes().toString().padStart(2, '0');
    //
    //   return `${year}-${month}-${day} ${hour}:${minute}`;
    // };
    // const toTime = function (tms) {
    //   return new Date(2000, 0, 1, tms.hour, tms.minute);
    // }
    // const roundTime = function (time, down = true) {
    //   const roundTo = 15 // minutes
    //   const roundDownTime = roundTo * 60 * 1000
    //
    //   return down
    //       ? new Date(time - time % roundDownTime)
    //       : new Date(time + (roundDownTime - (time % roundDownTime)));
    // };
    //
    // const startTime = function (tms) {
    //   const mouse = toTime(tms);
    //
    //   if (dragEvent.value && dragTime.value === null) {
    //     const start = dragEvent.value.start;
    //     dragTime.value = mouse - start;
    //   } else {
    //     createStart.value = roundTime(mouse);
    //     createEvent.value = {
    //       name: `Event`,
    //       start: toTimeStamp(createStart.value),
    //       end: toTimeStamp(createStart.value),
    //       timed: true,
    //     };
    //
    //     let newEvents = events.value;
    //     newEvents.push(createEvent.value);
    //     events.value = newEvents;
    //   }
    // };
    // const mouseMove = function (tms) {
    //   const mouse = toTime(tms);
    //
    //   if (dragEvent.value && dragTime.value !== null) {
    //     const start = dragEvent.start;
    //     const end = dragEvent.end;
    //     const duration = end - start;
    //     const newStartTime = mouse - dragTime.value;
    //     const newStart = roundTime(newStartTime);
    //     const newEnd = newStart + duration;
    //
    //     dragEvent.value.start = toTimeStamp(newStart);
    //     dragEvent.value.end = toTimeStamp(newEnd);
    //   } else if (createEvent.value && createStart.value !== null) {
    //     const mouseRounded = roundTime(mouse, false);
    //     const min = Math.min(mouseRounded, createStart.value);
    //     const max = Math.max(mouseRounded, createStart.value);
    //
    //     createEvent.value.start = toTimeStamp(new Date(min));
    //     createEvent.value.end = toTimeStamp(new Date(max));
    //   }
    // }
    // const startDrag = function ({event, timed}) {
    //   if (event && timed) {
    //     dragEvent.value = event
    //     dragTime.value = null
    //     extendOriginal.value = null
    //   }
    // };
    // const endDrag = function (e) {
    //   dragTime.value = null;
    //   dragEvent.value = null;
    //   createEvent.value = null;
    //   createStart.value = null;
    //   extendOriginal.value = null;
    // };
    // const cancelDrag = function () {
    //   if (createEvent.value) {
    //     if (extendOriginal.value) {
    //       createEvent.value.end = extendOriginal.value
    //     } else {
    //       const i = events.value.indexOf(createEvent.value)
    //       if (i !== -1) {
    //         let newEvents = events.value;
    //         newEvents.splice(i, 1);
    //         events.value = newEvents;
    //       }
    //     }
    //   }
    //
    //   createEvent.value = null
    //   createStart.value = null
    //   dragTime.value = null
    //   dragEvent.value = null
    // };

    return {
      eventClicked,

      // startTime,
      // mouseMove,
      // endDrag,
      // startDrag,
      // cancelDrag,
      //
      // events,
      processedEvents,
      // dragEvent,
      // dragTime,
      // extendOriginal,
      // createStart,
      // createEvent,
    }
  },
}
</script>

<style lang="less">
.event-body-container {
  width: 100%;
  position: absolute;
  left: 0;
  /*left: 0;*/
  top: 50%;
  font-weight: bold;
}

.event-body-label {
  transform: translateY(-50%)
}
</style>
